import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import GravityWellBehavior from "../../GravityWellBehavior";
import Player from "../../Player";

export default class GravityWell extends Ability {

    behavior: GravityWellBehavior|undefined;
    size = 512;

    constructor(player: Player) {
        super(player, {
            cooldown: 25,
            duration: 5,
            energyCost: 50,
            icon: 4,
            trigger: KeyCode.Digit2,
            triggerType: Input.GetKeyUp,
            info: `Gravity Well (25s cooldown) - Deploys a gravity bomb to the target location that implodes for 50 damage in a 128U radius, and creates a gravity well. For 5 seconds, the gravity well pulls in enemies in a 512U radius, then implodes again.`
        })
    }

    onUse(): void {
        const [, well] = this.player.engine.NewGameObjectWithScript<GravityWellBehavior>(GravityWellBehavior);
        this.behavior = well;
        this.behavior.transform.position = this.player.transform.position.clone();
        this.behavior.team = this.player.team;
        this.behavior.size = this.size;
        this.behavior.targetPosition = this.player.engine.mouseWorldPosition.clone();
        this.behavior.timer = this.duration;

        this.player.engine.sendCreatePacket(this.behavior.gameObject, {
            type: "GRAVITY_WELL",
            values: [
                {
                    key: "team",
                    value: this.behavior.team || "",
                    type: PacketValueSerialType.String
                },
                {
                    key: "size",
                    value: this.behavior.size,
                    type: PacketValueSerialType.UInt
                },
                {
                    key: "targetPosition",
                    value: this.behavior.targetPosition,
                    type: PacketValueSerialType.Vector2
                },
                {
                    key: "timer",
                    value: this.behavior.timer,
                    type: PacketValueSerialType.Byte
                },
            ]
        });
    }

    onKeydownDraw(): void {
        const ctx = this.player.ctx;
        const engine = this.player.engine;
        ctx.fillStyle = '#55ff5555';
        engine.FillCircle(engine.mouseWorldPosition, this.size);
        engine.FillCircle(engine.mouseWorldPosition, 128);
    }

}